export default __webpack_public_path__ + "static/media/single_angle_down.06e595d4.svg";